import { render, staticRenderFns } from "./TripNoteView.vue?vue&type=template&id=20ed4d7a"
import script from "./TripNoteView.vue?vue&type=script&lang=js"
export * from "./TripNoteView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports